import React from "react";

const PageItemSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">
      {[1, 2].map((index) => (
        <div key={index} className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-8">
            <div className="flex items-center gap-3">
              <div className="relative h-[38px] w-[38px] flex-shrink-0 overflow-hidden rounded-full bg-gray-200">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent" />
              </div>
              <div className="flex-1 space-y-1">
                <div className="relative h-6 w-48 overflow-hidden rounded bg-gray-200">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent" />
                </div>
                <div className="relative h-5 w-32 overflow-hidden rounded bg-gray-200">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent [animation-delay:0.2s]" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-4">
            <div className="flex items-center justify-end mr-4">
              <div className="relative h-7 w-24 overflow-hidden rounded-full bg-gray-200">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PageItemSkeleton;
